@if (isOpen) {
  <div class="nav-content">
    <ng-content></ng-content>
  </div>
}

<div
  class="nav-toggle-col"
  (click)="onToggle()"
  role="button"
  tabindex="0"
  (keydown.enter)="onToggle()"
  (keydown.space)="onToggle(); $event.preventDefault()"
>
  <div class="nav-control">
    <lib-icon name="list"></lib-icon>
  </div>
</div>
